import {cs}       from "./chain-services";
import {UseState} from "./use-state";

export const PositiveNumberInputBinding = ({state, isValid = (v) => true, next}) => cs(
    ["buffer", (_, next) => UseState({next})],
    ({buffer}) => next({
        onChange: (e) => {
            const raw = e.target.value;
            buffer.onChange(raw);
            if (!isNaN(raw) && raw >= 0 && isValid(+raw)) {
                state.onChange(Math.abs(Math.round((+raw)*100)/100));
            } else {
                state.onChange(null)
            }
        },
        onBlur: () => {
            buffer.onChange(null);
        },
    }),
);